import { createUniqueKey, logErrorToHasura, graphql } from "_shared/request";
import { msalJwtToken, user } from "_shared/auth";
import { getEnv } from "../../../../utils/constants";
import axios from "axios";
import { z } from "zod";

const instance = axios.create({
  baseURL: `${getEnv("SERVICENOW_BASE_URL")}`,
});

const fetchApiKey = async (key) => {
  let apiKey = "";
  const queryString = `
          query MyQuery {
            api_secrets {
              api_key
              id
              used_for
            }
          }
        `;
  try {
    const response = await graphql(queryString);
    for (const item of response.data.data.api_secrets) {
      if (item.used_for === key) {
        apiKey = item.api_key;
        break;
      }
    }
    return apiKey;
  } catch (e) {
    console.log("An error occurred trying to fetch the api key.", e);
  }
};

const azureADpostServiceNow = async (props) => {
  try {
    const SERVICENOW_AUTH = await fetchApiKey("SERVICENOW_AUTH");
    const response = instance({
      method: "post",
      ...props,
      params: {
        ...props.params,
      },
      headers: {
        ...props.headers,
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Basic ${SERVICENOW_AUTH}`,
      },
    });
    return response;
  } catch (error) {
    if (process.env.NODE_ENV === "production") {
      const errorDetails = {
        teamId: user.teamId || 0,
        message: error.message || "No error message.",
        stack: error.stack || "No error details provided.",
        httpRequest: {
          method: "POST",
          url: props.url,
          params: props.params || "No params provided.",
          headers: props.headers || "No headers provided.",
          data: props.data || "No data provided.",
        },
        httpResponse: {
          status:
            error.response?.status || "Server did not respond to the request.",
          statusText:
            error.response?.statusText ||
            "Server did not respond to the request.",
          data:
            error.response?.data || "Server did not respond to the request.",
        },
      };

      if (axios.isAxiosError(error)) {
        errorDetails.type = "HTTP";
      } else {
        errorDetails.type = "MISC";
      }
      logErrorToHasura(errorDetails, createUniqueKey(props));
    }
    console.error("request post error:", error);
    throw error;
  }
};

const azureADgetServiceNow = async (props, schema) => {
  try {
    const SERVICENOW_AUTH = await fetchApiKey("SERVICENOW_AUTH");
    const response = await instance({
      method: "get",
      ...props,
      params: {
        ...props.params,
      },
      headers: {
        ...props.headers,
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Basic ${SERVICENOW_AUTH}`,
      },
    });
    if (schema) {
      const validatedData = schema.parse(response.data);
      response.data = validatedData;
      return response;
    } else {
      return response;
    }
  } catch (error) {
    if (process.env.NODE_ENV === "production") {
      const errorDetails = {
        teamId: user.teamId || 0,
        message: error.message || "No error message.",
        stack: error.stack || "No error details provided.",
        httpRequest: {
          method: "GET",
          url: props.url,
          params: props.params || "No params provided.",
          headers: {
            ...props.headers,
            Authorization: `Basic ${SERVICENOW_AUTH}`,
          },
        },
        httpResponse: {
          status:
            error.response?.status || "Server did not respond to the request.",
          statusText:
            error.response?.statusText ||
            "Server did not respond to the request.",
          data:
            error.response?.data || "Server did not respond to the request.",
        },
      };

      if (axios.isAxiosError(error)) {
        errorDetails.type = "HTTP";
      } else if (error instanceof z.ZodError) {
        errorDetails.type = "VALIDATION";
        errorDetails.stack = error.issues;
      } else {
        errorDetails.type = "MISC";
      }
      logErrorToHasura(errorDetails, createUniqueKey(props));
    }
    console.error("azureADgetServiceNow request get error:", error);
    throw error;
  }
};

export const getApprovals = ({ params }) => {
  return azureADgetServiceNow({
    url: `${getEnv("SERVICENOW_BASE_URL")}/getapprovals`,
    params,
  });
};

export const getApprovalDetails = ({ params }) => {
  return azureADgetServiceNow({
    url: `${getEnv("SERVICENOW_BASE_URL")}/getrequestinfo`,
    params,
  });
};

export const getRequests = ({ params }) => {
  return azureADgetServiceNow({
    url: `${getEnv("SERVICENOW_BASE_URL")}/getrequests`,
    params,
  });
};

export const postApprovalAction = (data) => {
  let { approvalSysID, approvalTeamID, action, comments } = data;

  return azureADpostServiceNow({
    url: `${getEnv("SERVICENOW_BASE_URL")}/approvalAction`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },

    data: JSON.stringify({
      approval_sys_id: approvalSysID,
      approver_tm_id: approvalTeamID,
      action,
      comments,
    }),
  });
};
